import { render, staticRenderFns } from "./MaterialLinkPop.vue?vue&type=template&id=228022d6&scoped=true"
import script from "./MaterialLinkPop.vue?vue&type=script&lang=ts"
export * from "./MaterialLinkPop.vue?vue&type=script&lang=ts"
import style0 from "./MaterialLinkPop.vue?vue&type=style&index=0&id=228022d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228022d6",
  null
  
)

export default component.exports